export const GOOGLE_CALENDAR_LINK = 'https://calendar.google.com/calendar/u/0/r?tab=mc';
export const MS_CALENDAR_LINK = 'https://outlook.live.com/calendar/0/view/month';
